import { Injectable } from '@angular/core';
import { Category, Subcategory } from '@company-box/models';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  private category: string | undefined;
  private subcategory: string | undefined;
  private containerName: string = '';
  private isUpload: boolean = false;
  private productDetails: any;
  private reviewPageDetails: any;

  constructor() { }

  getCategory() {
    return this.category;
  }

  setCategory(category: string | undefined) {
    this.category = category;
  }

  getSubcategory() {
    return this.subcategory;
  }

  setSubcategory(subcategory: string | undefined) {
    this.subcategory = subcategory;
  }

  getContainerName() {
    return this.containerName;
  }

  setContainerName(containerName: string) {
    this.containerName = containerName;
  }

  getIsUpload() {
    return this.isUpload;
  }

  setIsUpload(isUpload: boolean) {
    this.isUpload = isUpload;
  }

  getProductDetails() {
    return this.productDetails;
  }

  setProductDetails(productDetails: any) {
    this.productDetails = productDetails;
  }

  getReviewPageDetails() {
    return this.reviewPageDetails;
  }

  setReviewPageDetails(reviewPageDetails: any) {
    this.reviewPageDetails = reviewPageDetails;
  }

  clearAll() {
    this.category = undefined;
    this.subcategory = undefined;
    this.containerName = '';
    this.isUpload = false;
    this.productDetails = undefined;
    this.reviewPageDetails = undefined;
  }
}
